

<template>
  <div class="signup app-content bg-blue">
    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">

            <router-link :to="'/job_mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./seeker/resume'">
              <p class="text-dark font14 under" style="display: inline;">あなたの履歴書を作成</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container px-5">
        <div class="row pt-4 mb-2 px-5 mx-3">
          <div class="col-12 p-5 bg-white">
            <b-row class='mt-2 border-orange px-5 py-2 mx-auto'>
              <b-col cols='12' class=' pb-2'>
                <h4>あなたの履歴書を作成</h4>
              </b-col>
              <b-col cols='12' class='mt-3'>
                <label class="pt-2">あなたのお名前のフリガナ</label>
                <b-form-input v-model="user.name_kana" class="dirty "></b-form-input>

                <label class="pt-2">あなたの年齢</label>
                <b-form-select v-model="user.age" class="dirty custom-select" :options="AGE_LIST"></b-form-select>

                <label class="pt-4">あなたの自国での最終学歴</label>
                <b-form-select v-model="user.final_education" class="dirty custom-select" :options="EDUCARIONALLIST"></b-form-select>

                <label class="pt-4">あなたの語学力</label>
                <b-form-select v-model="user.japanese_skil" class="dirty custom-select" :options="JAPANESELIST"></b-form-select>

                <label class="pt-4">あなたの国際免許の有無</label>
                <b-form-select v-model="user.is_driver_licence" class="dirty custom-select" :options="DORMITORY"></b-form-select>

                <label class="pt-4">あなたの日本在歴</label>
                <b-form-select v-model="user.experience_japan" class="dirty custom-select" :options="JAPAN_LIVE"></b-form-select>

                <label class="pt-4">あなたの配偶者有無</label>
                <b-form-select v-model="user.is_married" class="dirty custom-select" :options="DORMITORY"></b-form-select>
                
                <label class="pt-4">あなたの本国住所（実家)</label>
                <b-form-input v-model="user.home_address" class="dirty"></b-form-input>
                
                <label class="pt-4">あなたの出身地（パスポートに記載の各国県名）</label>
                <b-form-input v-model="user.home_prefecture" class="dirty"></b-form-input>
                
                <label class="pt-4">あなたの経歴</label>
                <b-textarea v-model="user.simple_resume" class="dirty" rows="7" ></b-textarea>

                <label class="pt-4">あなたのプロフィール写真</label>
                <select-image :imaga_url='user.profile_image' :index='index' :type='"profile_image"' @addImage='addImage'></select-image>


                <label class="pt-4">あなたの自己紹介動画</label>
                <select-movie :video_url='user.intro_movie' :index='1' :type='"intro_movie"' @addImage='addImage'></select-movie>

                <label class="pt-4">自己PR</label>
                <b-textarea v-model="user.self_pr" class="dirty" rows="7" ></b-textarea>

              </b-col>
              <b-col cols='12' class=' pb-2 text-center'>
                <b-button pill @click="patchUser" class='orange-button mt-4 px-4 no-border'>この内容で保存する</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SelectImage from "@/components/SelectImage";
import SelectMovie from "@/components/SelectMovie";
import axios from 'axios'

export default {
  components: {
    SelectImage, SelectMovie
  },
  data () {
    return {
      idToken: localStorage.idToken,
      user: {},
      intro_movie: "",
      profile_image: ""
    }
  },
  methods: {
    searchJobs: function() {
      this.$router.push('./jobs/search?industry=' + this.industry + '&prefecture=' + this.prefecture + '&income=' + this.income)
    },
    patchUser: function() {

      if(this.user.name_kana == "" || this.user.age == "") {
        alert("名前と年齢は必須です")
        return
      }

      this.$store.commit('setLoading', true)
      axios
        .patch(process.env.VUE_APP_API + "/users/" + this.user.id, {user: this.user, profile_image: this.user.profile_image, intro_movie: this.user.intro_movie}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
           this.$store.commit('user/setUser', response.data)
           this.$store.commit('setLoading', false)

           this.$swal.fire({
             icon: 'success',
             title: this.$i18n.t('message.change_success')
           }).then(() => {
             this.$router.push('/job_mypage')
           })
        })
    },
    addImage(data){
      if(data.type == 'profile_image'){
        this.user.profile_image = data.image
      }
      else if(data.type == 'intro_movie'){
        this.user.intro_movie = data.image
      }
    },


  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }

    await axios
      .get(process.env.VUE_APP_API + "/users/" + this.memberInfo.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.user = response.data
        this.$store.commit('setLoading', false)
      }).catch(error => {
        console.log('this is error', error)
      })
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  }
}

</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}
.no-border {
  border: none;
}
@media (max-width: 991.98px) {
  .p-5 {
     padding-left: 0px !important;
     padding-right: 0px !important;
  }
  .orange-button {
     width: 100%;
  }
}
</style>
